interface AuthSessionStorage {
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

interface AuthSessionIdentity {
  serviceToken: string;
  userId?: string | number;
  role?: string | null;
  waiterId?: string | number;
  restaurantIds?: string[];
}

export function replaceAuthSessionStorage(storage: AuthSessionStorage, identity: AuthSessionIdentity): void {
  storage.setItem('serviceToken', identity.serviceToken);
  storage.setItem('userId', identity.userId ? identity.userId.toString() : '');
  storage.setItem('role', identity.role || '');

  if (identity.waiterId !== undefined && identity.waiterId !== null && identity.waiterId !== '') {
    storage.setItem('waiterId', identity.waiterId.toString());
  } else {
    storage.removeItem('waiterId');
  }

  if (identity.restaurantIds && identity.restaurantIds.length > 0) {
    storage.setItem('restaurant_ids', identity.restaurantIds.toString());
  } else {
    storage.removeItem('restaurant_ids');
  }
}
